import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center overflow-hidden mx-4 md:mx-6 mb-4 md:mb-6 rounded-3xl">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20artistic%20composition%20with%20soft%20cream%20beige%20and%20sand%20gradients%2C%20gentle%20flowing%20shapes%2C%20minimalist%20elegant%20backdrop%2C%20subtle%20texture%2C%20editorial%20background%20design%2C%20clean%20sophisticated%20aesthetic%2C%20warm%20neutral%20tones%2C%20professional%20catalog%20style%20backdrop&width=1600&height=900&seq=cta-bg-v2-june2026&orientation=landscape"
          alt="AllChinaBuy Spreadsheet - Start Exploring Premium Categories"
          title="AllChinaBuy Spreadsheet CTA Background"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-6 md:px-14 py-16 md:py-24 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 lg:gap-16">
        <div>
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 font-bold leading-none lowercase">
            ready to buy?
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 lg:gap-6">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 bg-background-50 text-foreground-950 rounded-full text-base md:text-lg font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer group"
          >
            Buy It Now
            <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
              <i className="ri-arrow-right-up-line text-background-50 text-sm"></i>
            </span>
          </a>

          <Link
            to="/best-allchinabuy-spreadsheet/"
            className="inline-flex items-center gap-2 px-6 py-3 border border-background-50/40 text-background-50 rounded-full text-sm font-medium hover:bg-background-50/15 transition-all whitespace-nowrap cursor-pointer"
          >
            Read Complete Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <p className="text-background-50/80 text-sm md:text-base max-w-xs leading-relaxed">
          Jump to KASpreadsheet for the full catalog and live inventory. Updated weekly with the latest seller information and product listings.
        </p>
      </div>
    </section>
  );
}